export default __webpack_public_path__ + "static/media/jblheadphone.03fe9c7e.png";